export default "__VITE_ASSET__DEtnfIZl__"